export default __webpack_public_path__ + "static/media/KFOmCnqEu92Fr1Mu7GxKKTU1Kvnz.a49f43da.woff2";